module.exports = __webpack_public_path__ + "files/384584b419e10268a898fb43091a6eb0.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/ubuntu-italic-webfont.woff
 ** module id = 1034
 ** module chunks = 0
 **/